import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import useFirstRender from '../../hooks/FirstRender';
import { useDispatch } from 'react-redux';
import { getPurchaseById } from '../../api/purchaseApi';
import { getSupplierById } from '../../api/supplierApi';
import { getAllRolls } from '../../api/rollApi';
import SupplierPicker from '../../components/supplier/SupplierPicker';
import Input from '../../components/Input';
import { formatDate, onChange } from '../../utils/functions';
import Textarea from '../../components/Textarea';
import { FaArrowRotateLeft } from "react-icons/fa6";
import PurchaseReturnmentSubmitModal from '../../components/returnment/PurchaseReturnmentSubmitModal';
import { useApiProgress } from '../../hooks/ApiProgress';
import { PURCHASE_RETURN_PATH, addPurchaseReturn, chargePurchaseReturn, dechargePurchaseReturn, deletePurchaseReturn, getAllPurchaseReturns } from '../../api/purchaseReturnApi';
import { toast } from 'react-toastify';
import ProductLabel from '../../components/product/ProductLabel';
import { AiFillDelete } from 'react-icons/ai';
import DeleteModal from '../../components/DeleteModal';

const PurchaseReturnPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const { id } = useParams();
    const isFirstRender = useFirstRender()
    const nav = useNavigate()
    const dispatch = useDispatch()
    const [errors, setErrors] = useState({})
    const [rolls, setRolls] = useState([])
    const [purchase, setPurchase] = useState({})
    const [isOpenSubmitModal, setIsOpenSubmitModal] = useState(false)
    const [selectedRoll, setSelectedRoll] = useState({})
    const [returnAmount, setReturnAmount] = useState()
    const [returnPrice, setReturnPrice] = useState('')
    const [description, setDescription] = useState('')
    const [date, setDate] = useState('')
    const [returns, setReturns] = useState([])
    const pendingApiCall = useApiProgress('post', `${PURCHASE_RETURN_PATH}/page`, false)
    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false)
    const [deleteId, setDeleteId] = useState()

    useEffect(() => {
        getPurchaseById(id)
            .then(res => {
                setPurchase(res.data)
                getSupplierById(res.data.supplierId)
                    .then(res => {
                        setPurchase(prevState => ({ ...prevState, supplier: res.data }))
                    })
            })
            .then(() => {
                getAllRolls({ purchaseId: id })
                    .then(res => {
                        setRolls(res.data)
                    })
            })
        getAllPurchaseReturns({ purchaseId: id }).then(res => {
            setReturns(res.data)
        })
    }, [id])

    const onClickReturnRoll = (roll) => {
        setSelectedRoll(roll)
        setIsOpenSubmitModal(true)
        setReturnPrice(roll.unitPrice)
    }

    const onSubmitReturn = () => {
        const body = {
            unitPrice: returnPrice,
            quantity: returnAmount,
            rollId: selectedRoll?.id,
            purchaseId: id,
            description,
            returnmentDate: date,
        }
        addPurchaseReturn(body)
            .then(res => {
                setReturns(prev => ([...prev, res.data]))
                setIsOpenSubmitModal(false)
                toast.success('Kaydedildi')
                getAllRolls({ purchaseId: id })
                    .then(res => {
                        setRolls(res.data)
                    })
            }).catch(err => {
                setErrors(err.response.data.validationErrors)
                toast.error('Hata')
            })
    }

    const onClickDeleteReturn = (id) => {
        setDeleteId(id)
        setIsOpenDeleteModal(true)
    }

    const onClickDelete = () => {
        deletePurchaseReturn(deleteId)
            .then(res => {
                setReturns(prev => prev.filter(p => p.id !== deleteId))
                setDeleteId()
                setIsOpenDeleteModal(false)
                getAllRolls({ purchaseId: id })
                    .then(res => {
                        setRolls(res.data)
                    })
            })
    }

    useEffect(() => {
        if (!isOpenSubmitModal) {
            setReturnAmount()
            setReturnPrice()
            setDate('')
            setDescription('')
            setSelectedRoll({})
            setErrors({})
        }
    }, [isOpenSubmitModal])

    const onClickChargeReturn = (r) => {
        if (r.charged) {
            dechargePurchaseReturn(r.id)
                .then(res => {
                    setReturns(prev => prev.map(p => p.id === res.data.id ? res.data : p))
                })
        } else {
            chargePurchaseReturn(r.id)
                .then(res => {
                    setReturns(prev => prev.map(p => p.id === res.data.id ? res.data : p))
                })
        }
    }

    return (
        <div>
            <div className='mb-5'>
                <label className='text-xl'>Satın Alım İadesi</label>
            </div>
            <div className='border p-5 bg-white rounded-lg shadow-lg mb-5'>
                <label className='text-lg mb-3 block'>Detaylar</label>
                <div className='grid grid-cols-12 gap-x-3'>
                    {/* SUPPLIER PICKER */}
                    <SupplierPicker
                        label='Tedarikçi'
                        state={purchase.supplier}
                        disabled
                    />
                    <div className='col-span-2'>
                        <Input
                            name='purchaseDate'
                            label='Satın Alım Tarihi'
                            type='date'
                            value={purchase.purchaseDate}
                            error={errors?.purchaseDate}
                            onChange={e => onChange(e, setPurchase, setErrors)}
                            disabled
                        />
                    </div>
                    <div className='col-span-2'>
                        <Input
                            name='invoiceNumber'
                            label='Fatura Numarası'
                            type='text'
                            value={purchase.invoiceNumber}
                            error={errors?.invoiceNumber}
                            onChange={e => onChange(e, setPurchase, setErrors)}
                            placeholder='Fatura numarası girin...'
                            disabled
                        />
                    </div>
                    <div className='col-span-1'>
                        <Input
                            name='vat'
                            label='Vergi (%)'
                            type='number'
                            value={purchase.vat}
                            error={errors?.vat}
                            onChange={e => onChange(e, setPurchase, setErrors)}
                            placeholder='Vergi'
                            disabled
                        />
                    </div>
                    <div className='col-span-1'>
                        <Input
                            name='parity'
                            label='Parite'
                            type='number'
                            error={errors?.parity}
                            value={purchase.parity}
                            onChange={e => onChange(e, setPurchase, setErrors)}
                            placeholder='Parite'
                            disabled
                        />
                    </div>
                    <div className='col-span-3'>
                        <Textarea
                            name='description'
                            label='Açıklama'
                            type='text'
                            value={purchase.description}
                            onChange={e => onChange(e, setPurchase, setErrors)}
                            placeholder='Açıklama girin'
                            disabled
                        />
                    </div>

                </div>
                <table className='w-full text-left text-zinc-900 mb-3'>
                    <thead className='text-xs uppercase tracking-wide bg-white'>
                        <tr>
                            <th className='p-2 w-1/24'>#</th>
                            <th className='p-2 w-3/12'>Ürün</th>
                            <th className='p-2 w-2/12'>Lokasyon</th>
                            <th className='p-2 w-2/12 '>Kazan No</th>
                            <th className='p-2 w-1/12'>Metre</th>
                            <th className='p-2 w-1/24 normal-case'>{`BİRİM FİYAT ${purchase.supplier ? `(${purchase.supplier.currency}/m)` : ""}`}</th>
                            <th className='p-2 w-1/12 normal-case'>{`BİRİM MALİYET (USD/m)`}</th>
                            <th className='p-2 w-1/24'>Harcanan</th>
                            <th className='p-2 w-1/24'>Kalan</th>
                            <th className='p-2 w-1/12'>Aksiyon</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            rolls.map((roll, index) => (
                                <tr key={index} className='border-b items-center text-sm'>
                                    <td className='p-2'>
                                        <span className='text-xs'></span> {index + 1}
                                    </td>
                                    <td className='p-2'>{<ProductLabel state={roll.product} />} </td>
                                    <td className='p-2'>{roll.location?.name}</td>
                                    <td className='p-2'>{roll.boilerCode}</td>
                                    <td className='p-2'>{roll.quantity}</td>
                                    <td className='p-2'>{roll.unitPrice} <span className='text-xs'>{purchase.supplier ? `${purchase.supplier?.currency}/m` : ""}</span> </td>
                                    <td className='p-2'>{roll.unitCost?.toFixed(4)} <span className='text-xs'>USD/m</span></td>
                                    <td className='p-2'>{roll.spentQuantity}</td>
                                    <td className='p-2'>{roll.restQuantity}</td>
                                    <td className='p-2 items-center'>
                                        <span className='cursor-pointer hover:scale-125 hover:text-blue-600 duration-150' onClick={() => onClickReturnRoll(roll)}>
                                            <FaArrowRotateLeft />
                                        </span>
                                    </td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </div>
            <div className='border p-5 bg-white rounded-lg shadow-lg'>
                <label className='text-lg mb-3 block'>İadeler</label>
                <table className='w-full text-left text-zinc-900 mb-3'>
                    <thead className='text-xs uppercase tracking-wide bg-white'>
                        <tr>
                            <th className='p-2 w-1/24'>#</th>
                            <th className='p-2 w-3/12'>Ürün</th>
                            <th className='p-2 w-3/12'>Kazan No</th>
                            <th className='p-2 w-1/12'>İade Tarihi</th>
                            <th className='p-2 w-2/12 normal-case'>{`İADE BİRİM FİYAT ${purchase.supplier ? `(${purchase.supplier.currency}/m)` : ""}`}</th>
                            <th className='p-2 w-1/12'>İade Miktarı</th>
                            <th className='p-2 w-1/12'>Hesapta</th>
                            <th className='p-2 w-1/24'>Aksiyon</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            returns.map((r, index) => (
                                <tr key={index} className='border-b items-center text-sm'>
                                    <td className='p-2'>
                                        <span className='text-xs'></span> {index + 1}
                                    </td>
                                    <td className='p-2'>{<ProductLabel state={r.roll?.product} />} </td>
                                    <td className='p-2'>{r.roll.boilerCode}</td>
                                    <td className='p-2'>{formatDate(r.returnmentDate)}</td>
                                    <td className='p-2'>{r.unitPrice}</td>
                                    <td className='p-2'>{r.quantity} m</td>
                                    <td className='p-2 text-center flex'>
                                        <input
                                            type='checkbox'
                                            checked={r.charged}
                                            defaultChecked={r.charged}
                                            onChange={() => onClickChargeReturn(r)}
                                        />
                                    </td>
                                    <td>
                                        {
                                            !r.charged &&
                                            <span
                                                className='cursor-pointer hover:scale-125 hover:text-red-600 duration-150'
                                                onClick={() => onClickDeleteReturn(r.id)}
                                            >
                                                <AiFillDelete />
                                            </span>
                                        }

                                    </td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>

            </div>
            <PurchaseReturnmentSubmitModal
                isOpen={isOpenSubmitModal}
                closeModal={() => setIsOpenSubmitModal(false)}
                roll={selectedRoll}
                setReturnAmount={setReturnAmount}
                returnAmount={returnAmount}
                setReturnPrice={setReturnPrice}
                returnPrice={returnPrice}
                setDescription={setDescription}
                description={description}
                pendingApiCall={pendingApiCall}
                onClick={onSubmitReturn}
                setDate={setDate}
                date={date}
                errors={errors}
                setErrors={setErrors}
            />
            <DeleteModal
                isOpen={isOpenDeleteModal}
                closeModal={() => setIsOpenDeleteModal(false)}
                onClick={onClickDelete}
            />
        </div>
    )
}

export default PurchaseReturnPage